export default __webpack_public_path__ + "static/media/iconranger.b5849314.png";